module.exports = __webpack_public_path__ + "img/cisco.2f32e507.png";